module.exports = __webpack_public_path__ + "img/magnifyingglass.1a172ef3.svg";